import { Text } from 'components/Text';
import { React, useState } from 'libs/react';
import { FormInputPicker } from 'components/form/FormInputPicker';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { Button } from 'components/Button';
import { ClientListQuery } from 'graphql/Client/queries/ClientListQuery';
import { ClientQuickAddMenu } from 'modules/client/menus/ClientQuickAddMenu';
import { ClientQuickEditMenu } from 'modules/client/menus/ClientQuickEditMenu';
import { Phone } from 'components/Phone';
import { ClientListExternalQuery } from 'graphql/Client/queries/ClientListExternalQuery';
import './DealClientPanel.scss';
/**
 * @component DealClientPanel
 * @since 1.0.0
 */
export function DealClientPanel(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { style, deal } = Object.assign({ style: 'normal' }, props);
    const { updateDealField } = useDealConfiguratorContext();
    const [clientQuickAddOpen, setClientQuickAddOpen] = useState(false);
    const [clientEditOpen, setClientEditOpen] = useState(false);
    /**
     * @function onSelect
     * @since 1.0.0
     * @hidden
     */
    const onSelect = (selection) => {
        updateDealField('client', selection, 'object');
        if (selection.primaryLocation) {
            updateDealField('billTo', selection.primaryLocation, 'object');
            updateDealField('shipTo', selection.primaryLocation, 'object');
        }
        else {
            updateDealField('billTo', undefined, 'object');
            updateDealField('shipTo', undefined, 'object');
        }
        if (selection.currency) {
            updateDealField('currency', selection.currency, 'object');
        }
    };
    /**
     * @function onPress
     * @since 1.0.0
     * @hidden
     */
    const onPress = () => {
        updateDealField('client', undefined, 'undefined');
    };
    /**
     * @function onClientQuickAddClose
     * @since 1.0.0
     * @hidden
     */
    const onClientQuickAddClose = () => {
        setClientQuickAddOpen(false);
    };
    /**
     * @function onClientEditOpen
     * @since 1.0.0
     * @hidden
     */
    const onClientEditOpen = () => {
        setClientEditOpen(true);
    };
    /**
     * @function onClientEditClose
     * @since 1.0.0
     * @hidden
     */
    const onClientEditClose = () => {
        setClientEditOpen(false);
    };
    /**
     * @function onClientUpdateDone
     * @since 1.0.0
     * @hidden
     */
    const onClientUpdateDone = (updatedClient) => {
        updateDealField('client', updatedClient, 'object');
        // Update billTo and shipTo based on client's primary location
        if (updatedClient.primaryLocation) {
            updateDealField('billTo', updatedClient.primaryLocation, 'object');
            updateDealField('shipTo', updatedClient.primaryLocation, 'object');
        }
        else {
            updateDealField('billTo', undefined, 'object');
            updateDealField('shipTo', undefined, 'object');
        }
        // Update currency if client has one
        if (updatedClient.currency) {
            updateDealField('currency', updatedClient.currency, 'object');
        }
    };
    return (React.createElement("div", { className: "deal-client-panel" },
        React.createElement("div", { className: "deal-client-panel-container" }, !deal.client ? (React.createElement(FormInputPicker, { placeholder: `${t('Select or create a company')}`, createLabel: t('Create a company'), noResultsLabel: t('No company found.'), entity: "client", query: ClientListQuery, externalQuery: ClientListExternalQuery, objectType: "clients", externalObjectType: "clientsExternal", onSelect: (value) => {
                onSelect(value);
            }, format: (value) => ({
                id: value.id,
                title: value.name,
                infos: '',
                asset: value.asset
            }), creatable: true, onCreate: () => {
                setClientQuickAddOpen(true);
            }, singlePick: true })) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "deal-client-panel-container-button" },
                React.createElement(Text, { value: (_a = deal.client) === null || _a === void 0 ? void 0 : _a.name }),
                React.createElement("div", { className: "deal-client-panel-buttons" },
                    React.createElement(Button, { style: "picto", picto: "pen-to-square", size: "small", onPress: onClientEditOpen, className: "deal-client-panel-button" }),
                    React.createElement(Button, { style: "picto", picto: "xmark", size: "small", onPress: onPress, className: "deal-client-panel-button" }))),
            React.createElement(Text, { value: ((_c = (_b = deal.client) === null || _b === void 0 ? void 0 : _b.primaryLocation) === null || _c === void 0 ? void 0 : _c.primaryEmail)
                    ? (_e = (_d = deal.client) === null || _d === void 0 ? void 0 : _d.primaryLocation) === null || _e === void 0 ? void 0 : _e.primaryEmail.email
                    : '' }),
            React.createElement(Phone, { value: ((_g = (_f = deal.client) === null || _f === void 0 ? void 0 : _f.primaryLocation) === null || _g === void 0 ? void 0 : _g.primaryPhone)
                    ? (_j = (_h = deal.client) === null || _h === void 0 ? void 0 : _h.primaryLocation) === null || _j === void 0 ? void 0 : _j.primaryPhone.phone
                    : '' }),
            React.createElement("div", { className: "deal-client-panel-container-bill-ship" },
                deal.billTo ? (React.createElement("div", { className: "deal-client-panel-container-bill-to" },
                    React.createElement(Text, { className: "deal-client-panel-container-bill-to-title", value: t('Billing') }),
                    React.createElement(Text, { className: "deal-client-panel-container-bill-to-value", value: deal.billTo.address +
                            ', ' +
                            deal.billTo.city +
                            ', ' +
                            deal.billTo.province +
                            ', ' +
                            deal.billTo.country +
                            ', ' +
                            deal.billTo.postalcode }))) : (React.createElement(React.Fragment, null)),
                deal.shipTo ? (React.createElement("div", { className: "deal-client-panel-container-ship-to" },
                    React.createElement(Text, { className: "deal-client-panel-container-ship-to-title", value: t('Shipping') }),
                    React.createElement(Text, { className: "deal-client-panel-container-ship-to-value", value: deal.shipTo.address +
                            ', ' +
                            deal.shipTo.city +
                            ', ' +
                            deal.shipTo.province +
                            ', ' +
                            deal.shipTo.country +
                            ', ' +
                            deal.shipTo.postalcode }))) : (React.createElement(React.Fragment, null)))))),
        clientQuickAddOpen && (React.createElement(ClientQuickAddMenu, { open: clientQuickAddOpen, hideButton: true, redirect: false, onClientCreateDone: onSelect })),
        clientEditOpen && deal.client && (React.createElement(ClientQuickEditMenu, { open: clientEditOpen, client: deal.client, onClose: onClientEditClose, onClientUpdateDone: onClientUpdateDone }))));
}
